import React, { useState } from 'react';
import { MDBSideNavCollapse, MDBSideNavItem, MDBSideNavLink, MDBCheckbox, MDBSpinner } from 'mdb-react-ui-kit';

const Party = ({ userSelectedParty, setUserSelectedParty }) => {
    const [collapse, setCollapse] = useState(false);
    const [loadingId, setLoadingId] = useState(null);

    const parties = [
        { id: 'CONSTITUTIONAL', label: 'Constitutional' },
        { id: 'DEMOCRAT', label: 'Democrat' },
        { id: 'GREEN', label: 'Green' },
        { id: 'INDEPENDENT', label: 'Independent' },
        { id: 'LIBERTARIAN', label: 'Libertarian' },
        { id: 'REPUBLICAN', label: 'Republican' },
        { id: 'REFORM', label: 'Reform' }
    ];

    const handlePartyChange = async (partyId) => {
        setLoadingId(partyId);
        setUserSelectedParty(prev => {
            if (prev?.includes(partyId)) {
                return prev.filter(id => id !== partyId);
            } else {
                return [...(prev || []), partyId];
            }
        });
        await new Promise(resolve => setTimeout(resolve, 300));
        setLoadingId(null);
    };

    return (
        <MDBSideNavItem>
            <MDBSideNavLink icon='angle-down' shouldBeExpanded={collapse} onClick={() => setCollapse(!collapse)}>
                Party
            </MDBSideNavLink>
            <MDBSideNavCollapse open={collapse}>
                <div 
                    className="p-3" 
                    style={{
                        maxHeight: 'calc(100vh - 400px)',
                        overflowY: 'auto',
                        scrollbarWidth: 'thin',
                        scrollbarColor: '#999999 #f1f1f1'
                    }}
                >
                    {parties.map(party => (
                        <div key={party.id} className="d-flex align-items-center mb-2">
                            <MDBCheckbox
                                name={party.id}
                                id={party.id}
                                label={party.label}
                                checked={userSelectedParty?.includes(party.id) || false}
                                onChange={() => handlePartyChange(party.id)}
                                disabled={loadingId === party.id}
                            />
                            {loadingId === party.id && (
                                <MDBSpinner size='sm' className='ms-2' style={{ width: '20px', height: '20px' }} />
                            )}
                        </div>
                    ))}
                </div>
            </MDBSideNavCollapse>
        </MDBSideNavItem>
    );
};

export default Party;
